import { Box, Divider, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import fetchInstantGift from "hoc/fetch-instant-gift"

import Card from "./card"
import { Text } from "./components"
import PersonalizedVideo from "./personalized-video"
import ProductDetails from "./product-details"
import ProductImages from "./product-images"

const Wrapper = styled(Box).attrs((props) => ({
  mb: props.inModal ? 0 : { tablet: "80px" },
}))``

const InstantGift = ({ data, inModal, isDemo }) => {
  return (
    <Wrapper inModal={inModal}>
      {!isDemo && <Box bg="grey.5" mb={4} py={{ _: 8, tablet: 9 }} />}

      <Box contain px={2} textAlign="center">
        {isDemo && data.video && (
          <Box mb="10px" mt={3}>
            {/* <BlockTitle center>
              Instant Gift Demo – What Your Loved One Receives
            </BlockTitle> */}
            <PersonalizedVideo data={data} />
          </Box>
        )}
        <Box
          mb={inModal ? 3 : 7}
          mt={isDemo ? 0 : -130}
          mx={{ _: 0, tablet: "auto" }}
        >
          <Card data={data} />
        </Box>
      </Box>

      {!inModal && (
        <Box contain mb={{ _: 6, tablet: "80px" }} px={2}>
          {!isDemo && data.video && !data.video.errors && (
            <Box mb={{ _: 4, tablet: 8 }}>
              <PersonalizedVideo data={data} />
            </Box>
          )}
          <ProductImages
            product={{
              availableViews: data.available_views,
              image: data.image_url,
              prefs: data.prefs,
              productTitle: data.title,
              styleCode: data.style_code,
            }}
          />
          <Box
            mx="auto"
            textAlign="center"
            width={{ _: "100%", tablet: "640px" }}
          >
            <Typography fontSize="18px" lineHeight="28px">
              YOUR GIFT DETAILS
            </Typography>
            <Divider bg="grey.10" mb={3} mt="10px" />
            <ProductDetails
              details={data.details}
              productTitle={data.title}
              styleCode={data.style_code}
            />
            <Typography>Estimated Delivery Date:</Typography>
            <Text>{data.estimated_delivery_date}</Text>
          </Box>
        </Box>
      )}
    </Wrapper>
  )
}

InstantGift.propTypes = {
  data: PropTypes.object,
  inModal: PropTypes.bool,
  isDemo: PropTypes.bool,
}
export default fetchInstantGift(InstantGift)
